import { Badge } from '@/components/ui/badge';
import useFormattedDate from '@/hooks/useFormattedDate';
import { getTimeZone } from '@/utils/dates';
import {
  getReservationsTexts,
  groupReservationsByServiceDivisionGroupName
} from '@/utils/reservations';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ReservationsListProps } from './reservations-list.types';

export const ReservationsList: React.FC<ReservationsListProps> = ({
  reservations,
  organization
}) => {
  const hastDivisionGroups = reservations.some(
    (reservation) => reservation.serviceDivisionGroup
  );
  const { formattedDate } = useFormattedDate();

  if (hastDivisionGroups) {
    const reservatinosByDivisionGroup =
      groupReservationsByServiceDivisionGroupName(reservations);
    return reservatinosByDivisionGroup.map((reservation, index) => {
      const startDate = getTimeZone(
        new Date(reservation.reservations[0].startTime),
        organization.tz
      );
      const endDate = getTimeZone(
        new Date(
          reservation.reservations[reservation.reservations.length - 1].endTime
        ),
        organization.tz
      );

      const name = `${reservation.name} - ${formattedDate({ date: startDate, dateFormat: 'dateShort' })} - ${formattedDate({ date: endDate, dateFormat: 'dateShort' })}`;
      return (
        <div className="px-2 my-2 " key={reservation.id}>
          <p className="font-semibold">{name}</p>
          {reservation.reservations.map((reservation, index) => {
            return (
              <Link
                key={reservation.id}
                to={`/reservations/${reservation.id}`}
                className={`py-4 px-2 flex items-center justify-between border-gray-300 ${index === 0 ? '' : 'border-t'} `}
              >
                <span>{reservation.name}</span>
                <div className="flex items-center gap-2">
                  <Badge variant={reservation.status}>
                    {getReservationsTexts(reservation.status)}
                  </Badge>
                  <ChevronRight width={16} height={16} />
                </div>
              </Link>
            );
          })}
        </div>
      );
    });
  }

  return reservations.map((reservation, index) => (
    <Link
      key={reservation.id}
      to={`/reservations/${reservation.id}`}
      className={`py-4 px-2  flex items-center justify-between border-gray-300 ${
        index === 0 ? '' : 'border-t'
      } `}
    >
      <span>{reservation.name}</span>
      <div className="flex items-center gap-2">
        <Badge variant={reservation.status}>
          {getReservationsTexts(reservation.status)}
        </Badge>
        <ChevronRight width={16} height={16} />
      </div>
    </Link>
  ));
};
